import { useRouter } from "@tanstack/react-router";
import { PrimaryButton } from "@/components/PrimaryButton";
import { FloatingLeftButton } from "@/components/FloatingLeftButton";
import { useMediaQuery } from "@/lib/hooks/useMediaQuery";
import { cn } from "@/lib/utils";
import { ChevronLeft } from "lucide-react";
import { useEffect } from "react";
import { useSetAtom } from "jotai";
import { isErrorPageAtom } from "@/lib/atoms";
import { DefaultButton } from "./DefaultButton";

export function PixelNotFound() {
  const router = useRouter();
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const setIsErrorPage = useSetAtom(isErrorPageAtom);

  useEffect(() => {
    setIsErrorPage(true);
    return () => setIsErrorPage(false);
  }, [setIsErrorPage]);

  return (
    <div
      className={cn(
        "relative h-[100svh] text-white w-full max-w-md mx-auto flex flex-col overflow-x-hidden",
        isDesktop && "pt-2 pb-2 px-2",
      )}
    >
      <div
        className={cn(
          "relative flex-1 mx-auto w-full flex flex-col overflow-x-hidden bg-[#1D2A52]",
          isDesktop &&
            "rounded-xl ring-[3px] border-b-[3px] ring-black border-black",
        )}
      >
        <FloatingLeftButton
          onClick={() => router.navigate({ to: "/home" })}
          className="absolute left-0 top-4 z-50"
          icon={
            <svg
              className="w-4 h-4"
              viewBox="0 0 9 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 1V0H2V1H1V2H0V3H1V4H2V5H3V4H6V7H3V8H7V7H8V6H9V3H8V2H7V1H3Z"
                fill="white"
              />
            </svg>
          }
        />
        <div className="flex flex-1 flex-col items-center justify-center gap-6 px-6 text-center">
          <h1
            className="text-7xl text-[#cd4223]"
            style={{ fontFamily: "DeadRevolverDisplay" }}
          >
            404
          </h1>

          <img src="/assets/404.png" className="h-40 w-auto" alt="404" />

          <div className="space-y-2">
            <h2
              className="text-2xl opacity-90"
              style={{ fontFamily: "DeadRevolverDisplay" }}
            >
              PAGE NOT FOUND
            </h2>

            <p className="text-base opacity-60">
              This page doesn't exist or has been moved
            </p>
          </div>

          <DefaultButton
            className="w-32"
            onClick={() => router.navigate({ to: "/home" })}
          >
            Go Back
          </DefaultButton>
        </div>
      </div>
    </div>
  );
}
